export default __webpack_public_path__ + "static/media/events1.109e5cb9.jpg";